
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class vToggleSwitch extends Vue {
  @Prop() value!: boolean;

  changeHandler() {
    this.$emit('toggled', !this.value);
  }

}
